<template>
  <div class="about">
    <div class="container">
      <div class="organ">
        <el-link icon="el-icon-office-building" :underline="false">企业介绍</el-link>
        <!-- <p>Introduction</p> -->
        <div class="notes">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item>高质量</el-breadcrumb-item>
            <el-breadcrumb-item>快速度</el-breadcrumb-item>
            <el-breadcrumb-item>低成本</el-breadcrumb-item>
            <el-breadcrumb-item>客户满意</el-breadcrumb-item>
            <el-breadcrumb-item>诚实</el-breadcrumb-item>
            <el-breadcrumb-item>努力</el-breadcrumb-item>
            <el-breadcrumb-item>虚心</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <el-row :gutter="50">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="grid-content bg-purple">
              <!-- <div class="about-head">关于我们/ABOUT US</div> -->
              <div v-html="content" class="about_content">{{content}}</div>
             <div class="more-about">
                <el-button type="primary" @click="toMore()">了解更多</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
          content:''
      }
    },
    mounted() {
      this.axios.get(this.$http + "api/index/getAbout", {
          params: {

          }
        })
        .then((res) => {
          this.content = res.data.data[0].content;
        })
        .catch((err) => {})
    },
    methods: {
      toMore: function() {
        this.$router.push({
          path: '/about',
        })
      }
    }
  }
</script>

<style>
  /* .about_content span{
    font-size: 14px !important;
  } */

  .about_content p{
    text-indent: 2em;
  }
</style>



// WEBPACK FOOTER //
// src/components/About.vue